<script>

export default {
  name: 'DatesDialog',
  props: {
    lignes: {
      type: Array,
      default: () => []
    },
    isError: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<template>
  <div class="dialog-cnt">
    <header>
      <h2 class="error white--text">
        Attenion
      </h2>
    </header>

    <section>
      Pour les lignes suivantes, le délai de livraison est trop court :
      <ul>
        <li
          v-for="(ligne, index) in lignes"
          :key="index"
        >
          <span>{{ ligne.libelleArticle }}</span>
          <span>Du {{ ligne.datePrevueLivraison | date }} au {{ ligne.finDatePrevueLivraison | date }}</span>
          <span v-if="ligne.numBatiment">{{ ligne.numBatiment }}</span>
          <span class="liste-lieux">
            <RefValue
              v-if="ligne.codeTypeSilo1"
              :code="ligne.codeTypeSilo1"
              type="TYPE_SILO"
            />
            <RefValue
              v-if="ligne.codeTypeSilo2"
              :code="ligne.codeTypeSilo2"
              type="TYPE_SILO"
            />
            <RefValue
              v-if="ligne.codeTypeSilo3"
              :code="ligne.codeTypeSilo3"
              type="TYPE_SILO"
            />
          </span>

          <span> {{ ligne.quantiteCommande | formatDecimal(3) }} {{ ligne.codeUniteArticle| lowercase }}

          </span>
        </li>
      </ul>

      Merci de modifier vos lignes de commande

      <div class="actions">
        <v-btn
          outlined
          @click="$emit('submit', false)"
        >
          Fermer
        </v-btn>
      </div>
    </section>
  </div>
</template>
<style lang="scss" scoped>
.dialog-cnt {
  background-color: #f4f8f9;

  header h2 {
    padding: 0.8em 1.5em;
    font-weight: 400;
  }

  section {
    padding: 3em;

    & > *:not(:last-child) {
      margin-bottom: 1em;
    }
  }
}
.actions {
  margin-top: 2em;
  display: flex;
  justify-content: center;

  & > *:not(:last-child) {
    margin-right: 2em;
  }
}

li > span:not(:last-child) {
  &::after {
    content: "    -    ";
  }
}

@import "~vuetify/src/styles/settings/_variables";
@media #{map-get($display-breakpoints, 'xs-only')} {
  .dialog-cnt section {
    padding: 1em;
  }
}

.liste-lieux {
  & > *:not(:last-child) {
    margin-right: 5px;
    &::after {
      content: ",";
    }
  }
}
</style>
